import React, { Fragment, useContext } from 'react'
import { Button } from '@scentregroup/ui'
import trackEvent from '../../helpers/analytics-utils/track-event'
import { categories, actions } from '../../helpers/analytics-utils/constants'
import { WhatsOnSeeMoreContext } from '../../context'
import { WhatsOnItem } from '../../../types/whats-on'
import WhatsOnListItem from './whats-on-list-item'
import style from './index.scss'

export interface WhatsOnMoreListProps {
  range: string
  items: WhatsOnItem[]
}

export interface ContextType {
  state: { [key: string]: boolean }
  dispatch: (args: { type: string; range: string }) => void
}

const WhatsOnMoreList = ({
  range,
  items,
}: WhatsOnMoreListProps): React.ReactElement => {
  const { state, dispatch } = useContext(WhatsOnSeeMoreContext) as ContextType
  const showItems = state && state[range]
  const label = 'See more'
  return (
    <Fragment>
      {showItems &&
        items.map((item, i) => <WhatsOnListItem key={item.slug} item={item} />)}
      {!showItems && (
        <li className={style.showMore}>
          <Button
            type="primary"
            className={style.showMoreButton}
            onClick={() => {
              trackEvent(
                `${categories.WHATS_HAPPENING_SEE_MORE} - ${range}`,
                actions.CTA,
                label
              )
              return dispatch({ type: 'expand_see_more', range })
            }}
          >
            {label}
          </Button>
        </li>
      )}
    </Fragment>
  )
}

export default WhatsOnMoreList
